import type { PageLoad } from "./$types";
import type { Guide } from "../../types";

export const load: PageLoad = async function ({ parent }) {
  const { guides } = await parent();

  return {
    guides: guides as Guide[],
    pageBackgroundColor: "#eae9e1",
    pageTheme: "#eae9e1",
    pageTitle: "Guides"
  };
};
